<p-card>
    <h3>Connect Portal Configuration</h3>
    <p-tabView #tabs orientation="left" [(activeIndex)]="currentTabIndex">
        <p-tabPanel *ngFor="let rtype of relationshipTypes; index as i;" [header]="rtype.Description"
            [selected]="i == 0" [disabled]="syncing">

            <ng-template pTemplate="content">
                <div *ngFor="let config of rtype.Configuration" class="item-group">
                    <!-- TOP LEVEL  -->
                    <div class="flex-row top">
                        <p-checkbox 
                            (click)="toggleEnabled(config.AccessTypeKey);
                            resetChildSelection(config,stateModel[config.AccessTypeKey].Selected);
                            setDirty();"
                            [(ngModel)]="stateModel[config.AccessTypeKey].Selected" binary="true" 
                            ></p-checkbox>
                        <p [style.color]="(!config.Selected) ? 'gray':'black'">{{config.AccessTypeDisplay}}</p>
                        &nbsp;
                        <i class="pi pi-info-circle info-circle-gray"
                            pTooltip="{{config.AccessTypeDescription}}"></i>
                    </div>

                    <!-- WILL HAVE A MULTI select dropdown -->
                    <ng-template *ngIf="config.HasDetail then tplParentDetail;"></ng-template>

                    <!-- HAS CHILDREN -->
                    <ng-container *ngIf="config.ChildCount > 0">
                        <ng-container *ngFor="let child of config.Children">
                            <div class="flex-row sub-section">
                                <p-checkbox [(ngModel)]="child.Selected"
                                    (change)="(child.Selected = !child.Selected);" (click)="setDirty()" [disabled]="!config.Selected"
                                    binary="true"></p-checkbox>
                                   
                                <!-- 
                                        "CHILD" checkbox
                                        -->
                                <ng-container *ngIf="!child.HasDetail; else tplDetail">
                                    <p [style.color]="((!config.Selected && !child.selected)||(!child.Selected))? 'gray':'black'">
                                        {{child.AccessTypeDisplay}}
                                    </p>
                                    <div class="noDetailbox">&nbsp;
                                        <i class="pi pi-info-circle info-circle-gray"
                                            pTooltip="{{child.AccessTypeDescription}}"></i>
                                    </div>
                                    
                                </ng-container>                               
                            </div>
                                
                            <div class="flex-row sub-section">
                                <ng-template #tplDetail>
                                    <div class="ms-label-group">
                                        <p-multiSelect resetFilterOnHide="true" [(ngModel)]="child.Choices"
                                            (onChange)="onChangeSetting($event, child.Selections, child.AccessTypeKey);setDirty();"
                                            [disabled]="((!config.Selected && !child.selected)||(!child.Selected))"
                                            [maxSelectedLabels]="0" [defaultLabel]="child.AccessTypeDisplay"
                                            [options]="child.Selections" [optionLabel]="'ChildName'"
                                            >
                                        </p-multiSelect>
                                        <div class="ms-label">{{child.AccessTypeDisplay}}</div>
                                    </div>
                                    &nbsp;
                                    <i class="pi pi-info-circle info-circle-gray"
                                        pTooltip="{{child.AccessTypeDescription}}"></i>
                                    &nbsp;
                                    <span (click)="clickDetail($event, child);setDirty();"
                                        id="{{child.AccessTypeKey}}Selections" pTooltip="Click to view selections"
                                        [ngClass]="{
                                                    'check-circle-gray': !child.Choices.length,
                                                    'check-circle-green': child.Choices.length
                                                }">
                                        <i class="pi pi-check-circle"></i>
                                    </span>
                                </ng-template>
                                <div class="flex-row sub-section">
                                    <span *ngIf="child.Selected && child.Choices && !child.Choices.length" class="custom-error">Please select an option from drop down</span>
                                </div>
                            </div>
                        </ng-container>
                    </ng-container>

                    <ng-template #tplParent>
                        <p-checkbox (click)="setDirty();"></p-checkbox>
                        >
                        <p [style.color]="sectionsDisabled[config.AccessTypeKey]? 'gray':'black'">
                            {{config.AccessTypeDisplay}}</p>
                    </ng-template>

                    <!-- 
                            PARENT/SECTION LEVEL DROPDOWN
                            This will NOT be next to the checkbox
                        -->
                    <ng-template #tplParentDetail>
                        <div class="flex-row section">
                            <div class="ms-label-group">
                                <p-multiSelect resetFilterOnHide="true" [(ngModel)]="config.Choices"
                                    (onChange)="onChangeSetting($event, config.Selections, config.AccessTypeKey);setDirty();" [disabled]="!config.Selected"
                                    [defaultLabel]="config.AccessTypeKey === 'Expenses' ? 'Select Expense Categories Partner can view' : config.AccessTypeDisplay" 
                                    [options]="config.Selections"
                                    [maxSelectedLabels]="0"
                                    [optionLabel]="'ChildName'">
                                </p-multiSelect>
                                <div class="ms-label top">{{config.AccessTypeKey === 'Expenses' ? 'Select Expense Categories Partner can view' : config.AccessTypeDisplay}}</div>
                            </div>
                            &nbsp;
                            <i class="pi pi-info-circle info-circle-gray"
                                pTooltip="{{config.AccessTypeDescription}}" *ngIf="config.AccessTypeKey !== 'Expenses'"></i>
                            &nbsp;
                            <span (click)="clickDetail($event, config);setDirty();" pTooltip="Click to view selections"
                                [ngClass]="{
                                            'check-circle-gray': !config.Choices.length,
                                            'check-circle-green': config.Choices.length
                                        }">
                                <i class="pi pi-check-circle"></i>
                            </span>                          
                        </div>
                        <div class="flex-row sub-section">
                            <span *ngIf="config.Selected && config.Choices && !config.Choices.length" class="custom-error">Please select an option from drop down</span>
                        </div>
                    </ng-template>

                </div> <!-- iter:config -->
                <div class="flex-button-row main">
                    <button pButton label="Save" (click)="clickSave()" class="ui-button-primary"
                        [disabled]="syncing || !isDirty() || !formValid"></button>
                    <button pButton [disabled]="syncing || !isDirty()" label="Cancel" (click)="clickCancel()"
                        class="ui-button-secondary"></button>
                </div>
            </ng-template>

        </p-tabPanel>
    </p-tabView>
</p-card>

<app-view-configuration-type *ngIf="modal" [data]="selectedData" [group]="group" [(display)]="modal"></app-view-configuration-type>
<p-toast></p-toast>

<p-blockUI [target]="tabs" [blocked]="syncing">
    <i class="fa fa-lock fa-5x" style="position:absolute;top:25%;left:50%">Loading...</i>
</p-blockUI>

<p-toast position="center" key="confirmAction" (onClose)="onConfirmNo({'message':'NO-OP'})" [modal]="true"
    [baseZIndex]="5000">
    <ng-template let-message pTemplate="message">
        <div style="text-align: center">
            <i class="pi pi-exclamation-triangle" style="font-size: 3em"></i>
            <h3>{{message.summary}}</h3>
            <p>{{message.detail}}</p>
        </div>
        <div class="flex-button-row">
            <button type="button" [disabled]="syncing" pButton (click)="onConfirmYes(message.data)" label="Yes"
                class="ui-button-success"></button>
            <button type="button" [disabled]="syncing" pButton (click)="onConfirmNo(message.data)" label="No"
                class="ui-button-secondary"></button>
        </div>
    </ng-template>
</p-toast>